module.exports.useValidation = (value, rules) ->
  _validate = (value, rules, t) ->
    Object.entries(rules).reduce (errors, [fieldKey, rule]) =>
      # todo: handle nested objects
      if !Array.isArray(rule)
        validator = rule
        if validator
          result = validator value[fieldKey]
          errors[fieldKey] = t result.message, result.params unless result.valid
      else
        for validator in rule
          if validator
            result = validator value[fieldKey]
            errors[fieldKey] = t result.message, result.params unless result.valid
      errors
    , {}
  
  t = Em.I18n.t
  
  validate = ->
    _validate(value, rules(value), t)

  validate